/**
 * TODO
 * @class service_v3sSubtitleService
 * @memberOf v3sWbtPlayerApp:page:media
 */
angular.module('v3sWbtPlayerApp').factory('v3sSubtitleService', ["$document",function ($document) {
    var currentAudio = null;
    var subtitle;
    var subtitles = [];
    var container;
    var subtitleContentElement = null;
    var subtitleTimeLine = null;
    var subtitleController = function ($scope) {
        this.addLines = function (lines) {
            $scope.lines = lines;
        }
    }

    function addSubtitleElement(element) {
        container = angular.element(document.querySelector("v3s-subtitles"));
        container.append(element[0]);
        subtitles[element.attr("id")] = {
            element: element,
            rendered: false,
            timeline : null
        }
    }

    function show(content, media) {
        if (content == "" ) return;
        container.removeClass("subtitles-hidden");
        container.addClass("subtitles-shown");
        if (!!subtitle) {
            subtitle.element.css("visibility", "hidden");
            subtitle = null;
        }

        subtitle = subtitles["audiotext_" + media.id];
        currentAudio = media.id;
        var subtitlescope = subtitle.element.scope();
        subtitle.element.css("visibility", "visible");

        //Ich Splitte den Text
        $document.ready(function () {
            subtitle.timeline = subtitle.timeline || new TimelineMax({ paused: true });
            var subtitleContainer = angular.element(subtitle.element[0].querySelector(".subtitle-container"));
            var splittext = new SplitText(subtitleContainer, {
                type: "lines",
                linesClass: "subtitle-line"
            });

            var lines = splittext.lines;
            var linecount = lines.length;

            //Die "Seiten" mit den Audiotexten
            var pages = [];
            var pagelements = [];

            while (lines.length > 0) {
                if (lines.length > 3) {
                    pages.push(lines.splice(0, 3));
                } else {
                    pages.push(lines.splice(0));
                }
            }


            media.getDuration().then(function(res) {
                media.onTimeUpdate(function (time) {
                    if (!subtitle) return;
                    var timediff = time - subtitle.timeline.time();
                    if (timediff > 0 || timediff < 0) {
                        subtitle.timeline.time(time);
                    }

                });
                var duration = res;
                var steplength = duration / pages.length;

                //Für jede Seite ein Label auf der Timeline setzen
                if (!subtitle.rendered) {
                    angular.forEach(pages, function (page, $index) {

                        pagelements[$index] = angular.element('<div class="subtitle-page"></div>');
                        subtitleContainer.append(pagelements[$index]);

                        pagelements[$index].append(angular.element(page));
                        if ($index > 0) {
                            var labelname = "page_" + $index;
                            subtitle.timeline.addLabel(labelname);
                            //Animation der Zeilen die reinkommen
                            subtitle.timeline.from(pagelements[$index], 0.5, { xPercent: 100 }, steplength * $index)
                            .to(pagelements[$index - 1], 0.5, { xPercent: -100 }, steplength *$index);
                        }
                    });
                }
                subtitle.rendered = true;
            });
        });
    }

    function hide() {
        if (!!subtitle) {
            subtitle.element.css("visibility", "hidden");
        }
    }

    return {
        addSubtitleElement : addSubtitleElement,
        show: show,
        hide: hide,
        showContainer: function () {
            if (container) {
                container.addClass("subtitles-shown");
                container.removeClass("subtitles-hidden");
            }
        },
        hideContainer: function () {
            container.addClass("subtitles-hidden");
        }
    }
}]);
